import { FC, Fragment } from 'react'

import { UseMFABlockOptions } from '$actions/useMFABlock'

import { title, header, description } from '$blocks/common/auth.css'
import { AuthFactorCard, AuthFactorCardProps } from '$elements/AuthFactorCard'
import { choiceList, choiceListDivider } from './styles.css'

export type ChoiceProps = Pick<UseMFABlockOptions, 'data'> &
  Pick<AuthFactorCardProps, 'onClick' | 'disabled'>

export const Choice: FC<ChoiceProps> = ({
  data: { available_factors = [] },
  onClick,
  disabled
}) => (
  <>
    <header className={header}>
      <h2 className={title}>2FA Verification</h2>

      <p className={description}>Choose your preferred verification method.</p>
    </header>

    <main role="list" className={choiceList}>
      {available_factors.map((data, index) => {
        const isLast = index === available_factors.length - 1

        const { type } = data
        const icon: AuthFactorCardProps['icon'] = (() => {
          switch (type) {
            case 'email_otp':
              return 'email-tick'
            case 'sms_otp':
              return 'mobile-phone'
            case 'totp':
              return 'qr-code'
            case 'carro_id':
              return 'shield'
            case 'passkey':
              return 'key-round'
            case 'recovery_code':
              return 'case-sensitive'
            case 'password':
              return 'password-check'
            case 'lark_otp':
              return 'lark'
            default:
              return 'grear'
          }
        })()

        return (
          <Fragment key={data.type}>
            <AuthFactorCard
              role="listitem"
              icon={icon}
              data={data}
              onClick={onClick}
              disabled={disabled}
            />
            {!isLast && <hr className={choiceListDivider} />}
          </Fragment>
        )
      })}
    </main>
  </>
)

export default Choice
